import { useEffect, useState } from 'react';
import { useAckRatingCelebration, useRatingCelebration } from '../../api/hooks';
import { setCelebrationPending, useCelebrationSourceIdle } from '../../celebrationGate';
import { haptics } from '../../telegram';
import { track } from '../../analytics';
import { HexBadge } from './HexBadge';

const RING = 112;
const STROKE = 4;

/**
 * «Момент повышения уровня» личного рейтинга (RE2): bottom-sheet как C1, но
 * тише — ледяной, без искр. Монтируется в App.tsx рядом с CelebrationSheet.
 * Понижение уровня листа не показывает (движок молча опускает seen_level).
 */
export function RatingLevelUpSheet({ enabled }: { enabled: boolean }) {
  const celebration = useRatingCelebration(enabled);
  const ack = useAckRatingCelebration();
  const [dismissed, setDismissed] = useState(false);
  // Свой выход — после листов достижений (иначе шторки стакаются).
  const achievementsIdle = useCelebrationSourceIdle('achievements');

  const c = celebration.data;
  const hasData = Boolean(enabled && !dismissed && c);
  const visible = hasData && achievementsIdle;
  // Рекап отбора ждёт и лист повышения уровня. Pending — по ДАННЫМ, не по
  // видимости: пока мы стоим в очереди за листами достижений, рекап не должен
  // проскочить в щель между ними.
  useEffect(() => {
    setCelebrationPending('rating', hasData);
    return () => setCelebrationPending('rating', false);
  }, [hasData]);
  if (!visible || !c) return null;

  const close = () => {
    haptics.success();
    track('rating_level_up_ack', { level: c.level });
    void ack.mutateAsync().catch(() => undefined);
    setDismissed(true);
  };

  const r = (RING - STROKE) / 2;
  const dash = 2 * Math.PI * r;
  return (
    <div className="sheet-backdrop rating-levelup-backdrop">
      <div className="sheet rating-levelup" data-theme="dark" onClick={(e) => e.stopPropagation()}>
        <div className="rlu-label mono">НОВЫЙ УРОВЕНЬ</div>
        <div className="rlu-ring" style={{ width: RING, height: RING }}>
          <svg width={RING} height={RING}>
            <circle cx={RING / 2} cy={RING / 2} r={r} className="rlu-ring-track" strokeWidth={STROKE} fill="none" />
            {/* Кольцо «набирается» CSS-анимацией от пустого к полному. */}
            <circle
              cx={RING / 2}
              cy={RING / 2}
              r={r}
              className="rlu-ring-fill"
              strokeWidth={STROKE}
              strokeLinecap="round"
              strokeDasharray={dash}
              strokeDashoffset={dash}
              fill="none"
            />
          </svg>
          <div className="rlu-hex">
            <HexBadge level={c.level} size={60} />
          </div>
        </div>
        <div className="rlu-name">Уровень {c.level}</div>
        {c.title && <div className="rlu-title-slot">{c.title}</div>}
        <div className="rlu-value mono">
          {c.value} · порог {c.threshold}
        </div>
        <div className="rlu-context">Так держать — уровень растёт вместе с твоей игрой.</div>
        <button className="btn rlu-take" onClick={close}>
          Отлично
        </button>
      </div>
    </div>
  );
}
